import React, { useEffect, useState } from "react";
import styles from "./LiveSimulation.module.css";
import { Modal } from "react-bootstrap";
import CygnusForm from "../../../CygnusForm/CygnusForm";
import { FieldProps, FieldVariant, SectionLayout, SectionVariant } from "../../../InputFieldsController/InputFieldsController.utils";

interface LiveSimulationModalProps {
  show: boolean;
  onClose: () => void;
  fields: FieldProps[];
  intakeRules?: string;
  fieldVariant?: FieldVariant;
  sectionVariant?: SectionVariant;
  sectionLayout?: SectionLayout;
}

/**
 * LiveSimulation Component
 */

const LiveSimulationModal: React.FC<LiveSimulationModalProps> = ({
  show,
  onClose,
  fields,
  intakeRules,
  fieldVariant,
  sectionVariant,
  sectionLayout,
}) => {
  const [simualtionFields, setSimulationFields] = useState(fields);
  useEffect(() => {
    console.log("simualtionFields: ", fields)
    setSimulationFields(fields);
  }, [fields]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, setIsValid] = useState<boolean>(false);

  return (
    <Modal
      show={show}
      onHide={onClose}
      fullscreen
      dialogClassName={styles.simulationModal}
      keyboard={false}
    >
      <Modal.Header className={styles.simulationModalHeader} closeButton>
        <Modal.Title>Live Simulation</Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.simulationModalBody}>
        <CygnusForm
          fields={simualtionFields}
          onFieldsChange={setSimulationFields}
          onValidationChange={(valid) => setIsValid(valid)}
          formId={"live-preview-form"}
          intakeRules={intakeRules}
          fieldVariant={fieldVariant}
          sectionVariant={sectionVariant}
          sectionLayout={sectionLayout}
        />
      </Modal.Body>
    </Modal>
  );
};

export default LiveSimulationModal;
